module.exports = __webpack_public_path__ + "img/en.e5564902.svg";